"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientMeterIndexEligibilityState = exports.selectRequestTrackingState = exports.getUpdateOverconsumptionThreshold = exports.getUpdateTranquilityStatus = exports.getUpdateResidualLeakStatus = exports.getSendingMeterIndexTechnicalErrorMessage = exports.getConcatenatedCombinedDeliveryPointAdress = exports.getConcatenatedFirstDeliveryPointAdress = exports.getInseeCodeFromFirstDeliveryPointAddress = exports.getInseeCodeOrZipCodeFromFirstDeliveryPointAddress = exports.getIsPartnerContractEnabledForResidualLeakAlerts = exports.getIsPartnerContractEnabledForTranquilityAlerts = exports.getIsTranquilityServiceActive = exports.getOrderedAlerts = exports.getIsResidualLeakServiceActive = exports.getTranquilityAlerts = exports.getResidualLeakAlerts = exports.getOverConsumptionThreshold = exports.getOverConsumptionAlertsV2 = exports.getOverConsumptionAlerts = exports.getFirstDeliveryPoint = exports.getMeterSendingState = exports.getCurrentDeliveryPointAddressSecondPart = exports.getCurrentDeliveryPointAddressFirstPart = exports.getCombinedDeliveryPoint = exports.getCurrentDeliveryPoint = exports.getMeter = exports.getLastMeter = exports.getDeliveryPointsList = exports.getClientWorkOrderV2State = exports.getClientWorkOrderState = exports.getDeliveryPoint = void 0;
var utils_1 = require("../helper/utils");
/**
 * Récupère le state du delivery point address
 * @param {*} store Store redux hébergeant le state
 */
function getDeliveryPoint(states) {
    return states.deliveryPoint;
}
exports.getDeliveryPoint = getDeliveryPoint;
function getClientWorkOrderState(states) {
    return states.deliveryPoint.clientWorkOrders;
}
exports.getClientWorkOrderState = getClientWorkOrderState;
function getClientWorkOrderV2State(states) {
    return states.deliveryPoint.clientWorkOrdersV2;
}
exports.getClientWorkOrderV2State = getClientWorkOrderV2State;
function getDeliveryPointsList(states) {
    return states.deliveryPoint.deliveryPoints.data;
}
exports.getDeliveryPointsList = getDeliveryPointsList;
function getLastMeter(states) {
    return states.deliveryPoint.meterIndex.data;
}
exports.getLastMeter = getLastMeter;
function getMeter(states) {
    return (states.deliveryPoint.currentDeliveryPoint.data ||
        states.deliveryPoint.meterInfo.data);
}
exports.getMeter = getMeter;
function getCurrentDeliveryPoint(states) {
    return states.deliveryPoint.currentDeliveryPoint.data;
}
exports.getCurrentDeliveryPoint = getCurrentDeliveryPoint;
function getCombinedDeliveryPoint(states) {
    return states.deliveryPoint.combinedDeliveryPoint.data;
}
exports.getCombinedDeliveryPoint = getCombinedDeliveryPoint;
function getCurrentDeliveryPointAddressFirstPart(states) {
    var _a, _b, _c, _d;
    return "".concat((0, utils_1.getNotNullString)((_b = (_a = getCurrentDeliveryPoint(states)) === null || _a === void 0 ? void 0 : _a.geographicAddress) === null || _b === void 0 ? void 0 : _b.streetAddress), " ").concat((0, utils_1.getNotNullString)((_d = (_c = getCurrentDeliveryPoint(states)) === null || _c === void 0 ? void 0 : _c.geographicAddress) === null || _d === void 0 ? void 0 : _d.addressComplement), " ");
}
exports.getCurrentDeliveryPointAddressFirstPart = getCurrentDeliveryPointAddressFirstPart;
function getCurrentDeliveryPointAddressSecondPart(states) {
    var _a, _b;
    return "".concat((0, utils_1.getNotNullString)((_b = (_a = getCurrentDeliveryPoint(states)) === null || _a === void 0 ? void 0 : _a.geographicAddress) === null || _b === void 0 ? void 0 : _b.city), " ");
}
exports.getCurrentDeliveryPointAddressSecondPart = getCurrentDeliveryPointAddressSecondPart;
function getMeterSendingState(states) {
    return states.deliveryPoint.sendingMeterIndex;
}
exports.getMeterSendingState = getMeterSendingState;
function getFirstDeliveryPoint(states) {
    var deliveryPointsList = getDeliveryPointsList(states);
    if (deliveryPointsList.length > 0) {
        return deliveryPointsList[0];
    }
    else {
        return null;
    }
}
exports.getFirstDeliveryPoint = getFirstDeliveryPoint;
function getOverConsumptionAlerts(states) {
    return states.deliveryPoint.overConsumptionsAlerts.data;
}
exports.getOverConsumptionAlerts = getOverConsumptionAlerts;
function getOverConsumptionAlertsV2(states) {
    var _a;
    return (_a = states.deliveryPoint.alerts.data) === null || _a === void 0 ? void 0 : _a.overConsumptionAlerts;
}
exports.getOverConsumptionAlertsV2 = getOverConsumptionAlertsV2;
function getOverConsumptionThreshold(states) {
    var _a;
    return (_a = states.deliveryPoint.alerts.data) === null || _a === void 0 ? void 0 : _a.overConsumptionThreshold;
}
exports.getOverConsumptionThreshold = getOverConsumptionThreshold;
function getResidualLeakAlerts(states) {
    var _a;
    return (_a = states.deliveryPoint.alerts.data) === null || _a === void 0 ? void 0 : _a.residualLeakAlerts;
}
exports.getResidualLeakAlerts = getResidualLeakAlerts;
function getTranquilityAlerts(states) {
    var _a;
    return (_a = states.deliveryPoint.alerts.data) === null || _a === void 0 ? void 0 : _a.tranquilityAlerts;
}
exports.getTranquilityAlerts = getTranquilityAlerts;
function getIsResidualLeakServiceActive(states) {
    var _a;
    return (_a = states.deliveryPoint.alerts.data) === null || _a === void 0 ? void 0 : _a.isResidualLeakServiceActive;
}
exports.getIsResidualLeakServiceActive = getIsResidualLeakServiceActive;
function getOrderedAlerts(states) {
    return states.deliveryPoint.alerts.orderedData;
}
exports.getOrderedAlerts = getOrderedAlerts;
function getIsTranquilityServiceActive(states) {
    var _a;
    return (_a = states.deliveryPoint.alerts.data) === null || _a === void 0 ? void 0 : _a.isTranquilityServiceActive;
}
exports.getIsTranquilityServiceActive = getIsTranquilityServiceActive;
function getIsPartnerContractEnabledForTranquilityAlerts(states) {
    var _a;
    return (_a = states.deliveryPoint.alerts.data) === null || _a === void 0 ? void 0 : _a.isPartnerContractEnabledForTranquilityAlerts;
}
exports.getIsPartnerContractEnabledForTranquilityAlerts = getIsPartnerContractEnabledForTranquilityAlerts;
function getIsPartnerContractEnabledForResidualLeakAlerts(states) {
    var _a;
    return (_a = states.deliveryPoint.alerts.data) === null || _a === void 0 ? void 0 : _a.isPartnerContractEnabledForResidualLeakAlerts;
}
exports.getIsPartnerContractEnabledForResidualLeakAlerts = getIsPartnerContractEnabledForResidualLeakAlerts;
function getInseeCodeOrZipCodeFromFirstDeliveryPointAddress(states) {
    var deliveryPoint = getCurrentDeliveryPoint(states);
    return "".concat((0, utils_1.getNotNullString)((deliveryPoint === null || deliveryPoint === void 0 ? void 0 : deliveryPoint.geographicAddress.inseeCode)
        ? deliveryPoint === null || deliveryPoint === void 0 ? void 0 : deliveryPoint.geographicAddress.inseeCode
        : deliveryPoint === null || deliveryPoint === void 0 ? void 0 : deliveryPoint.geographicAddress.zipCode));
}
exports.getInseeCodeOrZipCodeFromFirstDeliveryPointAddress = getInseeCodeOrZipCodeFromFirstDeliveryPointAddress;
function getInseeCodeFromFirstDeliveryPointAddress(states) {
    var deliveryPoint = getCurrentDeliveryPoint(states);
    return "".concat((0, utils_1.getNotNullString)(deliveryPoint === null || deliveryPoint === void 0 ? void 0 : deliveryPoint.geographicAddress.inseeCode));
}
exports.getInseeCodeFromFirstDeliveryPointAddress = getInseeCodeFromFirstDeliveryPointAddress;
function getConcatenatedFirstDeliveryPointAdress(states) {
    var deliveryPoint = getCurrentDeliveryPoint(states);
    return "".concat((0, utils_1.getNotNullString)(deliveryPoint === null || deliveryPoint === void 0 ? void 0 : deliveryPoint.geographicAddress.streetAddress), " ").concat((0, utils_1.getNotNullString)(deliveryPoint === null || deliveryPoint === void 0 ? void 0 : deliveryPoint.geographicAddress.addressComplement), " ").concat((0, utils_1.getNotNullString)(deliveryPoint === null || deliveryPoint === void 0 ? void 0 : deliveryPoint.geographicAddress.zipCode), " ").concat((0, utils_1.getNotNullString)(deliveryPoint === null || deliveryPoint === void 0 ? void 0 : deliveryPoint.geographicAddress.city));
}
exports.getConcatenatedFirstDeliveryPointAdress = getConcatenatedFirstDeliveryPointAdress;
function getConcatenatedCombinedDeliveryPointAdress(states) {
    var deliveryPoint = getCombinedDeliveryPoint(states);
    return "".concat((0, utils_1.getNotNullString)(deliveryPoint === null || deliveryPoint === void 0 ? void 0 : deliveryPoint.geographicAddress.streetAddress), " ").concat((0, utils_1.getNotNullString)(deliveryPoint === null || deliveryPoint === void 0 ? void 0 : deliveryPoint.geographicAddress.addressComplement), " ").concat((0, utils_1.getNotNullString)(deliveryPoint === null || deliveryPoint === void 0 ? void 0 : deliveryPoint.geographicAddress.zipCode), " ").concat((0, utils_1.getNotNullString)(deliveryPoint === null || deliveryPoint === void 0 ? void 0 : deliveryPoint.geographicAddress.city));
}
exports.getConcatenatedCombinedDeliveryPointAdress = getConcatenatedCombinedDeliveryPointAdress;
/**
 * Récupère le message d'erreur suite à l'envoi d'un index
 * @param states Tous les state de l'application
 */
function getSendingMeterIndexTechnicalErrorMessage(states) {
    return states.deliveryPoint.sendingMeterIndex.technicalErrorMessage;
}
exports.getSendingMeterIndexTechnicalErrorMessage = getSendingMeterIndexTechnicalErrorMessage;
/**
 * Select the UpdateResidualLeak  status object
 * @param states SSM global state
 * @returns UpdateResidualLeak  status object
 */
function getUpdateResidualLeakStatus(states) {
    return states.deliveryPoint.updateResidualLeakStatus;
}
exports.getUpdateResidualLeakStatus = getUpdateResidualLeakStatus;
/**
 * Select the UpdateTranquility  status object
 * @param states SSM global state
 * @returns UpdateTranquility  status object
 */
function getUpdateTranquilityStatus(states) {
    return states.deliveryPoint.updateTranquilityStatus;
}
exports.getUpdateTranquilityStatus = getUpdateTranquilityStatus;
/**
 * Select the UpdateOverconsumptionThreshold value
 * @param states SSM global state
 * @returns UpdateOverconsumptionThreshold value
 */
function getUpdateOverconsumptionThreshold(states) {
    return states.deliveryPoint.updateOverconsumptionThreshold;
}
exports.getUpdateOverconsumptionThreshold = getUpdateOverconsumptionThreshold;
var selectRequestTrackingState = function (states) {
    return states.deliveryPoint.requestsTracking;
};
exports.selectRequestTrackingState = selectRequestTrackingState;
var getClientMeterIndexEligibilityState = function (states) {
    return states.deliveryPoint.sendingMeterIndexEligibility;
};
exports.getClientMeterIndexEligibilityState = getClientMeterIndexEligibilityState;
